"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _react = _interopRequireDefault(require("react"));
var _paths = require("../../../../config/paths");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var Avatar = exports.Avatar = /*#__PURE__*/function (_React$Component) {
  _inherits(Avatar, _React$Component);
  function Avatar(props) {
    var _this;
    _classCallCheck(this, Avatar);
    _this = _callSuper(this, Avatar, [props]);
    _this.handleImageErrored = _this.handleImageErrored.bind(_assertThisInitialized(_this));
    _this.powerHostBadge = _this.powerHostBadge.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Avatar, [{
    key: "handleImageErrored",
    value: function handleImageErrored(event) {
      var e = event;
      e.target.src = (0, _paths.buildImagePath)('no_avatar_placeholder.svg?v=rb');
    }
  }, {
    key: "powerHostBadge",
    value: function powerHostBadge() {
      var addPowerHostBadge = this.props.addPowerHostBadge;
      if (addPowerHostBadge) {
        return /*#__PURE__*/_react.default.createElement("img", {
          alt: "power host medal",
          className: "power-host-medal",
          src: (0, _paths.buildImagePath)('power-host-medal.svg?v=rb')
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        src = _this$props.src,
        id = _this$props.id,
        className = _this$props.className,
        dataSrc = _this$props.dataSrc;
      var avatarLink = "https://img.peerspace.com/image/upload/c_crop,g_custom/f_auto,fl_progressive/c_scale,dpr_auto,h_100,w_100/".concat(id);
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
        "data-src": dataSrc ? avatarLink : null,
        src: id ? avatarLink : src,
        alt: "avatar",
        onError: this.handleImageErrored,
        className: className ? className : 'avatar-img',
        "data-pin-nopin": "true",
        style: {
          maxWidth: this.props.maxWidth
        },
        ref: "avatar"
      }), this.powerHostBadge());
    }
  }]);
  return Avatar;
}(_react.default.Component);